import * as React from 'react';
import {Container} from './styles';
import {ReactSVG} from 'react-svg';
import logo from '../../../assets/logos/logoTopii.svg';

interface Props {
  src?: string;
  width?: number;
  height?: number;
  className?: any;
}

const Logo: React.FC<Props> = ({
  src = logo,
  width = 75,
  height = 75,
  className,
}) => {
  return (
    <Container className={className}>
      <ReactSVG
        src={src}
        beforeInjection={svg =>
          svg.setAttribute('style', `width: ${width}px; height: ${height}px`)
        }
      />
    </Container>
  );
};

export default Logo;
